import React, { useContext, useState } from 'react';
import {
  Box, Grid, TextField, Button, CircularProgress,
  Snackbar, Alert, Dialog, DialogTitle, DialogContent,
  DialogActions, Typography
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { createNewDealer, dealerVerifyAdminTools } from '../services/dealerServices';
import { AuthContext } from '../AuthContext';

// Validation schema
const DealerSchema = Yup.object().shape({
  dealerid: Yup.string().required('Dealer Id is required'),
  dealername: Yup.string().required('Dealer Name is required'),
  dealeraddress1: Yup.string(),
  dealercity: Yup.string(),
  dealercontactname: Yup.string(),
  dealerphone: Yup.string(),
  dealerstate: Yup.string(),
  dealerzip: Yup.string(),
});

const initialValues = {
  dealerid: '',
  dealername: '',
  dealeraddress1: '',
  dealercity: '',
  dealercontactname: '',
  dealerphone: '',
  dealerstate: '',
  dealerzip: '',
};


 export const DealerForm = () => {
    const {user}= useContext(AuthContext);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
  const [onConfirmReset, setOnConfirmReset] = useState(null);
  const [dealerVerified,setDealerVerified] = useState(false);

  const handleCloseSnackbar = () => setSnackbar(prev => ({ ...prev, open: false }));

  const handleResetClick = (resetForm) => {
    setOnConfirmReset(() => resetForm);
    setResetDialogOpen(true);
  };

  const confirmReset = () => {
    if (onConfirmReset) onConfirmReset();
    setResetDialogOpen(false);
  };


  const handleDealerVerified = async (e)=>{
    setSnackbar({ open: true, message: 'Verifying Dealer.Please Wait.', severity: 'success' });
    const value = e.target.value
    try{
      
     const response = await dealerVerifyAdminTools(value);
          console.log("search response : ", response);
          const data = response.data;
          if(data.length === 0){
            setDealerVerified(true)
            setSnackbar({ open: false, message: 'Verifying Dealer.Please Wait.', severity: 'success' });
          }else {
            setDealerVerified(false);
            setSnackbar({ open: true, message: `Dealer with ${value} was already registered`, severity: 'error' });
          }
        }catch(err){
          console.log(err);
          setSnackbar({ open: true, message: `Error while Verfying Dealer with ${value} Please Try again`, severity: 'error' });
        }

  }

  return (
    <Box sx={{ maxWidth: 800, p: 2 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={DealerSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            const res = await createNewDealer({...values,'crmSystem':'ServiceTitan', 'user':user.name});
            console.log("dealer create response :",res)
            setSnackbar({ open: true, message: 'Dealer created successfully.', severity: 'success' });
            resetForm();
          } catch (error) {
            setSnackbar({ open: true, message: error.message, severity: 'error' });
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ errors, touched, isSubmitting, handleChange, values, resetForm }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealerid"
                  label="Dealer Id"
                  value={values.dealerid}
                  onChange={handleChange}
                  onBlur={handleDealerVerified}
                  error={touched.dealerid && Boolean(errors.dealerid)}
                  helperText={touched.dealerid && errors.dealerid}
                  disabled={isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealername"
                  label="Dealer Name"
                  value={values.dealername}
                  onChange={handleChange}
                  error={touched.dealername && Boolean(errors.dealername)}
                  helperText={touched.dealername && errors.dealername}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealeraddress1"
                  label="Address1"
                  value={values.dealeraddress1}
                  onChange={handleChange}
                  error={touched.dealeraddress1 && Boolean(errors.dealeraddress1)}
                  helperText={touched.dealeraddress1 && errors.dealeraddress1}
                  disabled={!dealerVerified ||isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealercity"
                  label="City"
                  value={values.dealercity}
                  onChange={handleChange}
                  error={touched.dealercity && Boolean(errors.dealercity)}
                  helperText={touched.dealercity && errors.dealercity}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealercontactname"
                  label="Contact Name"
                  value={values.dealercontactname}
                  onChange={handleChange}
                  error={touched.dealercontactname && Boolean(errors.dealercontactname)}
                  helperText={touched.dealercontactname && errors.dealercontactname}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealerphone"
                  label="Phone"
                  value={values.dealerphone}
                  onChange={handleChange}
                  error={touched.dealerphone && Boolean(errors.dealerphone)}
                  helperText={touched.dealerphone && errors.dealerphone}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealerstate"
                  label="State"
                  value={values.dealerstate}
                  onChange={handleChange}
                  error={touched.dealerstate && Boolean(errors.dealerstate)}
                  helperText={touched.dealerstate && errors.dealerstate}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  name="dealerzip"
                  label="Zip"
                  value={values.dealerzip}
                  onChange={handleChange}
                  error={touched.dealerzip && Boolean(errors.dealerzip)}
                  helperText={touched.dealerzip && errors.dealerzip}
                  disabled={!dealerVerified || isSubmitting}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="contained"
                  type="submit"
                  fullWidth
                  disabled={!dealerVerified || isSubmitting}
                  startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
                >
                  {isSubmitting ? 'Saving...' : 'Save'}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  color="warning"
                  fullWidth
                  disabled={!dealerVerified || isSubmitting}
                  onClick={() => handleResetClick(resetForm)}
                >
                  Reset Form
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert severity={snackbar.severity} variant="filled" onClose={handleCloseSnackbar}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Reset Confirmation Dialog */}
      <Dialog
        open={resetDialogOpen}
        onClose={() => setResetDialogOpen(false)}
      >
        <DialogTitle>Confirm Reset</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to reset the form? All data will be cleared.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResetDialogOpen(false)}>Cancel</Button>
          <Button onClick={confirmReset} color="error" variant="contained">
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};


